// extracted by mini-css-extract-plugin
export default {"container":"Ck-z","disabled":"Dk-z","subtotal":"Ek-z","legal":"Fk-z"};